import { render, staticRenderFns } from "./addbenefit.vue?vue&type=template&id=2d28f4cd"
import script from "./addbenefit.vue?vue&type=script&lang=js"
export * from "./addbenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports